/**
 * @generated SignedSource<<053e6256712d343c6a7bc13b54afd611>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorCardFragment_facility$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useFacilityInstructorNoun_facility" | "useFacilityLessonBookingDays_facility">;
  readonly " $fragmentType": "InstructorCardFragment_facility";
};
export type InstructorCardFragment_facility$key = {
  readonly " $data"?: InstructorCardFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorCardFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorCardFragment_facility",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityLessonBookingDays_facility"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFacilityInstructorNoun_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "33542ae803685f1aba2a1a1fdfccc296";

export default node;
